const VEHICLE_TYPE_LABELS = {
    GSA_SCHEDULE: 'GSA Schedule',
    GWAC: 'GWAC',
    BPA: 'BPA',
    IDIQ: 'IDIQ',
    MAC: 'MAC',
    OTHER: 'Other'
};
export function vehicleTypeLabel(value) {
    return VEHICLE_TYPE_LABELS[value] ?? (value || '—');
}
